import "./slm.js";
import "./filter-posts.js";
import "./posts-pagination.js";
import "./search-posts.js";
import "./sort-posts.js";
import "./slm/slm-single-page.js";

import "../css/index.css";
import "../css/slm-map.scss";
import "../css/slm-table.scss";

(function ($) {
  $(document).ready(() => {
    /* =========================== Home page tabs query params ============================ */
    (() => {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get("tab");

      if (!tabParam) return;
      const tabLinks = $(".e-n-tabs .e-n-tab-title").get();

      tabLinks.forEach((tab, index) => {
        const tabText = tab.innerText.toLowerCase().trim();

        if (tabText.includes(tabParam.toLowerCase())) {
          setTimeout(() => tab.click(), 100);
          setTimeout(() => $(document).scrollTop(1250), 200);
        }
      });
    })();

    $(".e-n-tabs .e-n-tab-title").click(function (ev) {
      const tabName = $(this).text().toLowerCase().trim();
      const newUrl = new URL(window.location);
      newUrl.searchParams.set("tab", tabName);
      window.history.replaceState({}, "", newUrl);
    });

    /* =========================== Home faqs ============================ */

    $("#home-faqs details summary").click(function () {
      if ($(this).closest("details").attr("open") === undefined) {
        const accordionIndex = $(this).attr("data-accordion-index");

        $("#faqs-engagement").hide();
        $("#faqs-who").hide();
        $("#faqs-how").hide();

        switch (accordionIndex) {
          case "2":
            $("#faqs-who").removeClass("hide").fadeIn();
            break;
          case "3":
            $("#faqs-how").removeClass("hide").fadeIn();
            break;
          default:
            $("#faqs-engagement").removeClass("hide").fadeIn();
            break;
        }
      }
    });
  });
})(jQuery);
